import LoanProductPage from '@/pages/loan/components/LoanProductPage';

export default function CorporatePage() {
  return <LoanProductPage slug="corporate" />;
}